(() => {
  const roots = document.querySelectorAll('[data-case-set-lp]');

  roots.forEach((root) => {
    if (root.dataset.caseSetReady === 'true') return;
    root.dataset.caseSetReady = 'true';

    const state = { size: 'all', case: 'all', band: 'all' };
    const cards = Array.from(root.querySelectorAll('[data-case-set-card]'));
    const countNodes = root.querySelectorAll('[data-case-result-count]');
    const emptyNode = root.querySelector('[data-case-empty]');
    const productSection = root.querySelector('[id^="CaseSetProducts-"]');

    const setPressedState = (group) => {
      root.querySelectorAll(`[data-case-filter-group="${group}"]`).forEach((button) => {
        const active = button.dataset.caseFilterValue === state[group];
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };

    const matches = (card, group) => {
      const selected = state[group];
      if (selected === 'all') return true;
      const tokens = (card.dataset[group] || 'all').split(/\s+/);
      return tokens.includes('all') || tokens.includes(selected);
    };

    const update = () => {
      let visible = 0;
      cards.forEach((card) => {
        const show = matches(card, 'size') && matches(card, 'case') && matches(card, 'band');
        card.hidden = !show;
        if (show) visible += 1;
      });
      countNodes.forEach((node) => { node.textContent = String(visible); });
      if (emptyNode) emptyNode.hidden = visible !== 0;
    };

    root.querySelectorAll('[data-case-filter-group]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.dataset.caseFilterGroup;
        state[group] = button.dataset.caseFilterValue;
        setPressedState(group);
        update();
      });
    });

    root.querySelector('[data-case-filter-reset]')?.addEventListener('click', () => {
      Object.keys(state).forEach((group) => {
        state[group] = 'all';
        setPressedState(group);
      });
      update();
    });

    root.querySelectorAll('[data-case-style-trigger]').forEach((button) => {
      button.addEventListener('click', () => {
        state.band = button.dataset.caseStyleTrigger;
        setPressedState('band');
        update();
        productSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    update();
  });
})();

